import { render } from "./zone-settings.vue?vue&type=template&id=f5cba4c4"
import script from "./zone-settings.vue?vue&type=script&lang=js"
export * from "./zone-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__